export class ProductListState {
	static NOT_LOGGED_IN = "NOT_LOGGED_IN";
	static LOGGED_IN = "LOGGED_IN";
}